import { Button, ButtonProps, Tooltip, TooltipProps } from '@mantine/core'

export interface ShibaButtonProps
  extends
    Omit<ButtonProps, 'disabled'>,
    Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'color' | 'style' | 'disabled'> {
  disabledReason?: string | null
  tooltipPosition?: TooltipProps['position']
}

export default function ShibaButton({ disabledReason, tooltipPosition, ...props }: ShibaButtonProps) {
  if (disabledReason) {
    return (
      <Tooltip label={disabledReason} position={tooltipPosition}>
        <Button disabled {...props} />
      </Tooltip>
    )
  }
  return <Button {...props} />
}
